import classNames from 'classnames'

const ColoredBar = ({
  bars,
  heightClassName,
  heading,
  stacked = false,
}: {
  bars?: { color?: string; perc?: string; name?: string }[]
  heightClassName?: string
  heading?: string
  stacked?: boolean
}) => {
  if (!bars?.length) return null
  return (
    <>
      <p className="mb-2 text-base">{heading}</p>
      <div className={`${heightClassName ?? 'h-3'} flex w-full`}>
        {bars.map(bar => (
          <div
            key={bar.name}
            style={{ backgroundColor: bar.color, width: bar.perc }}
            className="h-full opacity-70"
          />
        ))}{' '}
      </div>
      <div
        className={classNames('mt-3 lg:grid lg:gap-x-10', {
          'lg:grid-cols-2': !stacked,
          'lg:grid-cols-1': stacked,
        })}
      >
        {bars.map(bar => (
          <div
            key={bar.name}
            className="text-brand-black my-2 flex items-center text-sm"
          >
            <div
              style={{ backgroundColor: bar.color }}
              className="mr-2 h-3 w-3 opacity-70"
            />
            <div className="flex w-full justify-between">
              <div>{bar.name}</div>
              <div>{bar.perc}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default ColoredBar
